import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".count-up-block");

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.2,
  };

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const block = entry.target;
        animateBlock(block);
        observer.unobserve(block);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  const animateBlock = (block) => {
    const captions = block.querySelectorAll(".figure-caption");
    const description = block.querySelector(".figure-description");
    const hDivider = block.querySelector(".h-divider");

    const tl = gsap.timeline();

    if (hDivider) {
      tl.fromTo(
        hDivider,
        { height: 0 },
        { height: "100%", duration: 1, ease: "power2.out" },
        "start"
      );
    }

    captions.forEach((caption) => {
      const rawHTML = caption.innerHTML;

      const match = rawHTML.match(/([+\-]?)(\d+(?:[.,]\d{3})*(?:[.,]\d+)?)/);
      if (!match) return;

      const prefix = match[1];
      const numberText = match[2];

      const parts = numberText.split(/[.,]/);
      const lastPart = parts[parts.length - 1];
      const hasThousandsSeparator =
        parts.length > 2 || (parts.length === 2 && lastPart.length === 3);
      const useComma = numberText.includes(",");

      let cleanNumber = numberText;
      if (hasThousandsSeparator) {
        cleanNumber = useComma
          ? numberText.replace(/\./g, "").replace(",", ".")
          : numberText.replace(/\./g, "");
      } else {
        cleanNumber = numberText.replace(",", ".");
      }
      const numberValue = parseFloat(cleanNumber);

      const fullMatch = match[0];
      const matchIndex = rawHTML.indexOf(fullMatch);
      const before = rawHTML.substring(0, matchIndex);
      const after = rawHTML.substring(matchIndex + fullMatch.length);

      const hasDecimals = parts.length > 1 && lastPart.length < 3;
      const significantDecimals = hasDecimals
        ? lastPart.replace(/0+$/, "").length
        : 0;

      caption.innerHTML = `
        ${before}
        <span class="prefix">${prefix}</span>
        <span class="countup">${numberText}</span>
        ${after}
      `;

      const span = caption.querySelector(".countup");
      const counterObj = { val: 0 };

      tl.from(
        caption,
        {
          yPercent: 100,
          opacity: 0,
          duration: 0.5,
          ease: "expo.out",
        },
        "start"
      );

      tl.to(
        counterObj,
        {
          val: numberValue,
          duration: 1,
          ease: "power2.out",
          onUpdate: () => {
            let formatted;
            if (hasDecimals) {
              const decimals = Math.max(significantDecimals, 1);
              formatted = counterObj.val.toFixed(decimals);
              if (useComma) {
                formatted = formatted.replace(".", ",");
              }
            } else {
              formatted = Math.floor(counterObj.val).toString();

              if (hasThousandsSeparator) {
                const separator = useComma ? "." : ".";
                formatted = formatted.replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  separator
                );
              }
            }
            span.textContent = formatted;
          },
        },
        "<"
      );

      tl.fromTo(
        description,
        { yPercent: 100, opacity: 0 },
        { yPercent: 0, opacity: 1, duration: 2, ease: "expo.out" },
        "start"
      );
    });
  };

  blocks.forEach((block) => {
    observer.observe(block);
  });

  ScrollTrigger.refresh();
});
